import { render, staticRenderFns } from "./logisTransRecords.vue?vue&type=template&id=4e79ddbe&scoped=true&"
import script from "./logisTransRecords.vue?vue&type=script&lang=js&"
export * from "./logisTransRecords.vue?vue&type=script&lang=js&"
import style0 from "./logisTransRecords.vue?vue&type=style&index=0&id=4e79ddbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e79ddbe",
  null
  
)

component.options.__file = "logisTransRecords.vue"
export default component.exports